import localforage from 'localforage';

function createStore(config) {
  return localforage.createInstance(config);
}

export default {
  createStore
};
